const ClassIcon = () => {
  return (
    <svg viewBox="0 0 20.336 16.408">
      <path
        d="M33.717,78.949a1.562,1.562,0,0,0-1.563,1.563v11.72H43.093V90.669h4.224l.464.781-.464.781h3.589V80.512a1.562,1.562,0,0,0-1.563-1.563Zm12.5,3.125a.781.781,0,0,1,.552,1.334l-3.907,3.907a.781.781,0,0,1-1.1,0l-1.792-1.791-3.354,3.354a.781.781,0,0,1-1.1-1.1l3.907-3.907a.781.781,0,0,1,1.1,0l1.792,1.792L45.666,82.3A.782.782,0,0,1,46.218,82.074ZM32.154,93.794a.781.781,0,1,0,0,1.563H50.906a.781.781,0,1,0,0-1.563Z"
        transform="translate(-31.362 -78.949)"
      />
    </svg>
  );
};

export default ClassIcon;
